import React from 'react';
import PropTypes from 'prop-types';
import ActivismBlockInfo from '../../../02_molecules/ActivismBlockInfo';
import Webform from '../../Webform';

import styles from './index.module.scss';

const BBActivismWebform = ({
  webform,
  isRecaptchaEnabled,
  title = '',
  subtitle = '',
  uuid = null,
  nonce,
}) => (
  <div className={`bb ${styles['bb-activism-webform']}`} id={uuid}>
    <ActivismBlockInfo title={title} subtitle={subtitle} size="large" />

    <div className="container">
      <div className={styles['bb-activism-webform__content-wrapper']}>
        <Webform webform={webform} isRecaptchaEnabled={isRecaptchaEnabled} nonce={nonce} />
      </div>
    </div>
  </div>
);

BBActivismWebform.propTypes = {
  uuid: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  webform: PropTypes.object.isRequired,
  isRecaptchaEnabled: PropTypes.bool.isRequired,
  nonce: PropTypes.string.isRequired,
};

export default BBActivismWebform;
